import React from "react";
import { Grid, Button, Icon } from 'semantic-ui-react';

class UserComment extends React.Component {

    state = {
        errors: null
    }

    closeDock() {
        this.props.handleInboxVisibleChange(false)
    }

    render() {

        let windowHeight = window.innerHeight;
        return (
            <React.Fragment>
                <h4 className="pane_header">
                    Discussion
                    <Icon name="close" className="closeIcon" onClick={() => this.closeDock()} />
                </h4>
                <Grid className="settingPane" style={{ maxHeight: windowHeight - 52, overflow: "auto" }}>
                    <Grid.Row columns={1}>
                        <Grid.Column>
                            coming soon...
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </React.Fragment>
        );
    }
}
export default UserComment;